export enum ZenIconsEnum {
  // Commodity
  ELECTRIC = 'lightbulb',
  NAT_GAS = 'local_fire_department',

  // Pages
  CUSTOMER = 'language',

  // NavBar
  PORTFOLIO = 'layers',

  // Action icons
  INFO = 'info',
  SETTINGS = 'settings',
  BACK = 'chevron_left',
  PROCUREMENT_SNAPSHOT = 'photo_camera',

  // Contracts icons
  GREEN = 'eco',
  STANDARD_MIX = 'timelapse',

  // RULE: Add badge when contract is booked through our system
  TAX_EXEMPT = 'verified',
  STAR = 'star',

  PERSON = 'person',

  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  STATE = 'place',
  USAGE = 'bar_chart',
  SWING = 'show_chart',
  SEND = 'send',
  CAPACITY = 'monitoring',
  TRANSMISSION = 'cable',

  DONE = 'check_circle',
  ERROR = 'error_outline',

  EDIT_DOC = 'edit_document', // Upload LOE

  DEACTIVATE = 'hide_source',

  STAGGERED = 'align_horizontal_left',
  CALENDAR = 'today',
  FUTURE_CALENDAR = 'event_upcoming',
  PRICING_STRATEGY = 'contract_edit', // Custom, Matrix
  DOWN_ARROW = 'keyboard_arrow_down',
  RIGHT_ARROW = 'keyboard_arrow_right',
  CSA = 'apartment',
  MATRIX = 'checklist',

  ARROW_FORWARD = 'arrow_forward',

  REJECT = 'cancel_schedule_send',
  HELP = 'help',
  CLOSE = 'close',
  SWEET_SPOT = 'cake',
  WARNING = 'warning',

  SUBMIT_BIDS = 'send',
  EDIT = 'edit',
  VIEW_BIDS = 'turn_right',
  INCUMBENT_SUPPLIER = 'beenhere',
  OPT_OUT = 'cancel',
  TROPHY = 'emoji_events',

  TIMER = 'timer',
  SEARCH = 'search',
  SOUTH = 'south'
}
